import { modalAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } =
	createMultiStyleConfigHelpers(modalAnatomy.keys)

// define custom variants
const variants = {
	activityMenuModal: {
		dialog: {
			background: 'gray.500',
			boxShadow:
				'0px 6px 20px rgba(24, 39, 75, 0.2), 0px 10px 32px rgba(24, 39, 75, 0.1)',
			borderRadius: '20px',
		},
		header: {
			fontSize: '1rem',
			fontWeight: '500',
		},
		closeButton: {
			color: 'red.600',
		},
		body: {
			pt: '1.6rem',
			px: '3rem',
		},
		footer: {
			pt: '5rem',
			pb: '1rem',
		},
	},
	roundRight: {},
}

// export the custom variants in the component theme
export const ModalStyle = defineMultiStyleConfig({ variants })
